<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'무인보관함 불러오기'"
      :modal="true"
      :width="'400px'"
      style="display:none;">
    <template>
      <div class="pop-container">
        <div class="pop-conts">
          <div>
            <dd>
              <label>무인보관함</label>
              <ul class="w100">
                <li class="box_flex">
                  <kendo-dropdownlist
                      class="w100"
                      ref="SelectLockerRef"
                      v-model="lockerInfo.lockerId"
                      :option-label="'무인보관함을 선택해주세요.'"
                      :data-source="areaLockerList"
                      :data-text-field="'lockerNm'"
                      :data-value-field="'lockerId'"
                      :index="0"
                  >
                  </kendo-dropdownlist>
                </li>
              </ul>
            </dd>
          </div>
          <div class="button_area mgt30">
            <ul>
              <li class="w100">
                <button type="button" class="large_btn orange" @click="onClickConfirm">확인</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </template>
  </kendo-window>
</template>

<script>
import ApiConfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

import Apiconfig from '@/api/api.config'

export default {
  name: 'lockerSelectWindow',
  props: {area:{type:String, default:""}},
  mounted () {
    const vm = this
  },
  methods: {
    // 거점별 무인보관함 목록 호출 API
    getLockerList () {
      const vm = this
      const url = `${Apiconfig.eklDomain}/v1/ebmp/ai/manager/portal/kiosk/areaLockerList.json`
      const params = {
        loginUserToken: vm.loginUserToken,
        area: vm.area
      }
      ApiUtil.post(url, params).then(response => {
        if (response.data === undefined || response.data.resultStatus === undefined) {
          kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
          return false
        }
        const resultStatus = response.data.resultStatus
        if (resultStatus.messageCode !== '2000') {
          kendo.alert(resultStatus.messageText)
          return false
        }
        const resultData = response.data.resultData
        vm.areaLockerList = resultData
      })
    },
    // 확인 버튼
    async onClickConfirm () {
      const vm = this
      if (vm.validation()) {
         vm.selectLocker()
      }
    },
    // 유효성 체크
    validation () {
      const vm = this
      //필수값 체크
      if (!!!vm.lockerInfo.lockerId) {
        kendo.alert('무인보관함을 선택하세요')
        return
      }
      return true
    },
    // 무인보관함 선택 정보 emit
    selectLocker(){
      const vm = this
      const selectedLocker = vm.areaLockerList.find(locker => locker.lockerId === vm.lockerInfo.lockerId)
      const data = {
        lockerId: vm.lockerInfo.lockerId,
        lockerNm: selectedLocker.lockerNm,
        lockerDesc: selectedLocker.lockerDesc,
        lockerUseYn: selectedLocker.lockerUseYn,
      }
      vm.onClickClose()
      vm.$emit('selectLocker',data)
    },
    onClickClose(){
      const refs = this.$refs
      refs.kendoWindowRef.kendoWidget().close()
    }
  },
  data: function() {
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      lockerInfo: {
        lockerId: null,
        lockerNm: null,
        lockerUseYn: null,
      },
      areaLockerList: [],
    }
  },
}
</script>
